/* eslint-disable import/no-named-as-default */
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
import { Box, Grid, useTheme, useMediaQuery } from '@material-ui/core';
import RequestPinCard from './RequestPinCard';
import ValidatePinCard from './ValidatePinCard';
import PDFCard from './PDFCard';
import SingAlertController from './SingAlertController';

export const SignerLayout = ({ pinRequested }: Props): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: 'calc(100vh - 240px)',
        display: 'flex',
        flexDirection: 'column',
      }}
      data-testid="signer-layout"
    >
      <Box sx={{ marginBottom: 10 }}>
        <Grid container justifyContent="center">
          <Grid item container xs={12} md={10} lg={8} xl={6} spacing={2}>
            <SingAlertController />
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
        }}
      >
        <Grid container justifyContent="center">
          <Grid container item xs={12} md={10} lg={8} xl={6} spacing={2}>
            <PDFCard isMobile={isMobile} />
            {!pinRequested ? (
              <RequestPinCard
                data-testid="request-pin-card"
                isMobile={isMobile}
              />
            ) : (
              <ValidatePinCard
                data-testid="validate-pin-card"
                isMobile={isMobile}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  pinRequested: boolean;
} => ({
  pinRequested: state.signature.pinRequested,
});

const connector = connect(mapStateToProps, {});
type Props = ConnectedProps<typeof connector>;

export default connector(SignerLayout);
